<!--  -->
<template>
  <div>
    <div>
      <div>
        <el-form :label-position="labelPosition" label-width="90px" :model="formLabelAlign">
          <el-form-item label="标题">
            <el-input v-model.trim="formLabelAlign.name" style="width:200px" />
          </el-form-item>
          <el-form-item label="上传封面">
            <div>
              <img v-if="formLabelAlign.programimg" class="li_img" :src="formLabelAlign.programimg">
            </div>
            <el-button type="primary" size="mini" @click="materiallibrary">素材库选择</el-button>
          </el-form-item>
          <el-form-item label="小程序类型">
            <el-select v-model="formLabelAlign.appid" placeholder="请选择" @change="chawer">
              <el-option
                v-for="items in programtype"
                :key="items.mini_program_type"
                :label="items.type_name"
                :value="items.mini_program_type"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="跳转地址">
            <el-input v-model.trim="formLabelAlign.link" style="width:200px" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="margin-left:65px;margin-top:10px"><el-button type="primary" @click="sumbit">确定</el-button></div>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
  </div>
</template>

<script>
import chooseimg from '../../menumanagement/components/chooseimg.vue'
import { mptypeslist } from '@/api/sourceMaterial.js'
export default {
  components: { chooseimg },
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        programimg: '',
        sourceMaterialId: null,
        appid: null,
        link: ''
      },
      dialogVisibletwo: false,
      programtype: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    materiallibrary() {
      this.dialogVisibletwo = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    chawer(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      const index = this.programtype.findIndex(v => v.mini_program_type == val)
      this.formLabelAlign.link = this.programtype[index].index_path
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = data.data.types
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      this.formLabelAlign.programimg = img
      this.formLabelAlign.sourceMaterialId = key
    },
    send(item) {
      this.getmptypeslist()
      // eslint-disable-next-line eqeqeq
      if (JSON.stringify(item) == '{}') {
        console.log('item', item)
      } else {
        console.log('item1', item)
        this.formLabelAlign.name = item.title
        this.formLabelAlign.sourceMaterialId = item.source_material_id
        this.formLabelAlign.link = item.page
        this.formLabelAlign.appid = item.appid
        this.formLabelAlign.programimg = item.pic_media_src
      }
    },
    sumbit() {
      if (this.formLabelAlign.name === '') {
        this.$message.error('请填写标题')
        return
      }
      if (this.formLabelAlign.sourceMaterialId === null) {
        this.$message.error('请选择封面')
        return
      }
      if (this.formLabelAlign.appid === null) {
        this.$message.error('请选择小程序类型')
        return
      }
      if (this.formLabelAlign.link === '') {
        this.$message.error('请填写跳转地址')
        return
      }
      console.log(this.formLabelAlign)
      this.$emit('callwechat', this.formLabelAlign)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.examples_rightbox{
  margin-left: 30px;
}
.input_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.cover_box{
  display: flex;
  align-items: center;
}
.uopatatextimg{
  width: 80px;
  height: 80px;
  margin-top: 20px;
  margin-left: 40px;
}
.li_img{
  width: 80px;
  height: 80px;
}
</style>
